/**
 * WizardNavigation - Navigation buttons for the prosumer wizard.
 *
 * Shows context-appropriate buttons: Wstecz, Dalej, Oblicz, Pomiń, Od nowa.
 */

import { Button, Group } from '@mantine/core';
import { IconArrowLeft, IconArrowRight, IconCalculator, IconRefresh, IconPlayerSkipForward } from '@tabler/icons-react';
import type { WizardStep } from '../../types';

export interface WizardNavigationProps {
  currentStep: WizardStep;
  isFirstStep: boolean;
  isLastInputStep: boolean;
  isOnResults: boolean;
  onNext: () => void;
  onPrevious: () => void;
  onSkipDevices: () => void;
  onRestart: () => void;
}

export function WizardNavigation({
  currentStep,
  isFirstStep,
  isLastInputStep,
  isOnResults,
  onNext,
  onPrevious,
  onSkipDevices,
  onRestart,
}: WizardNavigationProps) {
  return (
    <Group justify="space-between" mt="xl">
      <Group>
        {!isFirstStep && !isOnResults && (
          <Button
            variant="default"
            leftSection={<IconArrowLeft size={16} />}
            onClick={onPrevious}
          >
            Wstecz
          </Button>
        )}
      </Group>

      <Group>
        {currentStep === 'devices' && !isOnResults && (
          <Button
            variant="subtle"
            leftSection={<IconPlayerSkipForward size={16} />}
            onClick={onSkipDevices}
          >
            Pomiń urządzenia
          </Button>
        )}

        {isOnResults ? (
          <Group>
            <Button
              variant="default"
              leftSection={<IconArrowLeft size={16} />}
              onClick={onPrevious}
            >
              Wstecz
            </Button>
            <Button
              leftSection={<IconRefresh size={16} />}
              onClick={onRestart}
            >
              Od nowa
            </Button>
          </Group>
        ) : isLastInputStep ? (
          <Button
            leftSection={<IconCalculator size={16} />}
            onClick={onNext}
          >
            Oblicz
          </Button>
        ) : (
          <Button
            rightSection={<IconArrowRight size={16} />}
            onClick={onNext}
          >
            Dalej
          </Button>
        )}
      </Group>
    </Group>
  );
}
